import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooterCompact() {
  return (
    <footer className="bg-[#0f172a] text-white/70 py-10" data-testid="site-footer-compact">
      <div className="mx-auto max-w-7xl px-5 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <img
            src="/tradecure-logo.png"
            alt="Tradecure"
            className="h-8 w-8 object-contain"
            width="32"
            height="32"
          />
          <span className="font-heading text-xl font-extrabold tracking-tight text-white">
            tradecure
          </span>
        </div>
        <div className="flex flex-wrap gap-6 text-sm">
          <Link to="/" className="hover:text-white">Home</Link>
          <Link to="/knowledge-hub" className="hover:text-white">Knowledge Hub</Link>
          <Link to="/blog" className="hover:text-white">Blog</Link>
          <Link to="/#waitlist" className="hover:text-white">Join Waitlist</Link>
        </div>
        <p className="text-xs text-white/50 max-w-md md:text-right">
          © {new Date().getFullYear()} Tradecure. Educational content only — not financial
          advice. Trade with capital you can afford to lose.
        </p>
      </div>
    </footer>
  );
}
